import { Transition } from "@headlessui/react";
import clsx from "clsx";
import { useState, type JSX } from "react";

import { SearchFlyout } from "./SearchFlyout";
import { getCurrentSectionLayout, type ActiveFlyout } from "./Sections";

interface Props {
  activeFlyout: ActiveFlyout;
}

/**
 * Painel flutuante do header desktop. Mostra busca ou a seção ativa e anima a entrada/saída.
 * Guarda o último conteúdo exibido para não "piscar" vazio durante a transição de saída.
 */
export const Flyout = ({ activeFlyout }: Props): JSX.Element => {
  const [displayedFlyout, setDisplayedFlyout] = useState<ActiveFlyout>(activeFlyout);

  if (activeFlyout && activeFlyout !== displayedFlyout) {
    setDisplayedFlyout(activeFlyout);
  }

  const isSearch = displayedFlyout === "busca";

  return (
    <Transition
      show={activeFlyout !== null}
      as="div"
      className={clsx(
        "absolute inset-x-0 top-full z-30 pt-2 transition duration-200 ease-out",
        "data-[closed]:-translate-y-1 data-[closed]:opacity-0",
      )}
    >
      <div
        className={clsx(
          "rounded-3xl bg-base-white p-4 shadow-[0_12px_40px_-8px_rgba(0,0,0,0.25)]",
          isSearch && "mx-auto w-[75%]",
        )}
      >
        {isSearch ? <SearchFlyout /> : getCurrentSectionLayout(displayedFlyout)}
      </div>
    </Transition>
  );
};
